import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import CodeInfoSection from 'components/CodeInfoSection';
import { Typography } from 'material-ui';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoAdditionalUnit extends Component {

    render() {
        const { unitName } = this.props;
        const summary = getTitleSummary(unitName)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Дополнительная единица измерения'],
                    rows: summary
                }}
                expanded={false}
            >
                {unitName.length &&
                    <Typography>{unitName.join(', ')}</Typography>
                }

            </CodeInfoSection>
        );
    }
}

function getTitleSummary(unitName) {
    return unitName.length !== 0 ? [[unitName.join(', ')]] : null
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoAdditionalUnit.js